var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.currentPlan.is_iha ? _c('div', {
    staticClass: "text-justify iha-agreement-text-container"
  }, [_vm._m(0), _c('p', [_vm._v(" You currently have the option to change your plan and/or network for a January 1 effective date. However, please note the following important details: ")]), _vm._m(1), _vm._m(2)]) : _c('div', {
    staticClass: "text-justify iha-agreement-text-container"
  }, [_vm._m(3), _vm._m(4), _vm._m(5), _c('p', [_vm._v(" This opportunity to change plans is time-sensitive, so please ensure you submit your application before the December 15 deadline. If you have questions or need assistance, don’t hesitate to reach out to your representative. Making an informed decision is key to selecting the best plan for your circumstances. ")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "agreement-heading"
  }, [_c('strong', [_vm._v("Important Information About Changing Your Medical Plan or Network")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('ol', {
    staticClass: "agreement-condition-container"
  }, [_c('li', [_c('strong', [_vm._v("1. Rate Guarantee Period")])]), _c('li', [_vm._v("While you can make changes to your plan or network, the 12-month rate guarantee remains tied to your original effective date. This means the guaranteed rate period does not reset with the January 1 change and will end 12 months from your initial plan start date.")])]), _c('ol', {
    staticClass: "agreement-condition-container"
  }, [_c('li', [_c('strong', [_vm._v("2. Understand the Differences")])]), _c('li', [_vm._v("If switching to a new plan or network, be aware that coverage, costs, and benefits may differ. We strongly recommend reviewing all options to ensure the new plan or network aligns with your needs.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v(" If you’re considering making a change, be sure to submit your request by "), _c('strong', [_vm._v("December 15")]), _vm._v(" for a January 1 effective date. If you have any questions or need guidance, please don’t hesitate to reach out to your representative. Understanding these terms is essential to making an informed decision ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "agreement-heading"
  }, [_c('strong', [_vm._v("Important Information About Changing Your Medical Plan")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v(" You have the option to change your medical plan between "), _c('strong', [_vm._v("November 23 and December 15")]), _vm._v(" for a January 1 effective date. If you're considering switching from your current union medical plan to a non-union medical plan, please carefully review the following important details: ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('ol', {
    staticClass: "agreement-condition-container"
  }, [_c('li', [_c('strong', [_vm._v("1. Approval Is Not Guaranteed")])]), _c('li', [_vm._v("Switching to a non-union medical plan requires underwriting. This means your application will be reviewed based on specific criteria, such as your health status and other factors. Approval is not guaranteed, and there is a possibility that your application may not be accepted.")])]), _c('ol', {
    staticClass: "agreement-condition-container"
  }, [_c('li', [_c('strong', [_vm._v("2. Rate Guarantee Period")])]), _c('li', [_vm._v("If your application is approved, the rates for the non-union medical plan are guaranteed for 12 months only. After this period, rates may be subject to change.")])]), _c('ol', {
    staticClass: "agreement-condition-container"
  }, [_c('li', [_c('strong', [_vm._v("3. Understand the Differences")])]), _c('li', [_vm._v("Non-union medical plans may differ in terms of coverage, costs, and benefits compared to your union medical plan. We encourage you to carefully review and compare the options to ensure they meet your needs.")])])]);
}]

export { render, staticRenderFns }